export default function ProblemSection() {
  return (
    <section
      id="problem"
      className="relative nfp-section bg-[#0a0a0a] overflow-hidden"
      data-testid="section-problem"
    >
      <div className="absolute inset-0 nfp-grid-bg opacity-30" />
      <div className="max-w-4xl mx-auto px-6 md:px-10 relative z-10 text-center">
        <p className="text-[11px] tracking-[0.3em] uppercase text-[#00E5FF] mb-6">
          The Problem
        </p>
        <h2
          className="nfp-heading text-white text-4xl md:text-6xl leading-[1] tracking-tight"
          data-testid="problem-headline"
        >
          Random workouts <br className="hidden md:block" />
          create{" "}
          <span className="text-white/30">random results.</span>
        </h2>
        <p className="mt-8 text-lg md:text-xl text-white/65 leading-relaxed max-w-2xl mx-auto">
          Most people train without a plan — progressing too fast, too slow, or
          burning out. NFP gives you{" "}
          <span className="text-white font-semibold">structure</span>,{" "}
          <span className="text-white font-semibold">progression</span>, and{" "}
          <span className="text-white font-semibold">purpose</span>.
        </p>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {[
            { v: "0", l: "Plans" },
            { v: "∞", l: "Variation" },
            { v: "?", l: "Progress" },
            { v: "—", l: "Recovery" },
          ].map((s) => (
            <div key={s.l} className="bg-[#0a0a0a] p-6 text-center">
              <div className="nfp-heading text-3xl md:text-4xl text-white/40">{s.v}</div>
              <div className="mt-1 text-[10px] uppercase tracking-[0.25em] text-white/40">
                Random training
              </div>
              <div className="mt-0.5 text-xs text-white/35">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
